import React from "react";
import { useNavigate } from "react-router-dom";
import { KRUMAGO } from "../../../s3-assets/Krumago";

const CategorySection = ({ categories }) => {
    const navigate = useNavigate();

    return (
        <div className="text-center px-2 sm:px-4 lg:px-8 py-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8 text-gray-800 relative">
                Shop By Category
                <span className="absolute left-0 bottom-0 w-full h-1 bg-[#B88E2F] transform scale-x-0 origin-left transition-transform duration-500 ease-in-out"></span>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
                {categories.map((category, index) => (
                    <div
                        key={index}
                        className="relative overflow-hidden rounded-full transition-transform transform hover:scale-105 cursor-pointer group"
                        onClick={() =>
                            navigate(`/category/sf/${category.name}`, {
                                state: { name: category.name },
                            })
                        }
                        style={{
                            width: "200px",  
                            height: "200px",
                            margin: "0 auto",
                        }}
                    >
                        <img
                            loading="lazy"
                            src={category.imageURL || KRUMAGO.IMAGES.ELE}
                            alt={category.name}
                            className="w-full h-full object-cover rounded-full transition-transform duration-500 ease-in-out transform group-hover:scale-110"
                        />
                        <div className="absolute inset-0 flex items-center justify-center bg-[#B88E2F] bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out rounded-full">
                            <h3 className="text-lg sm:text-xl font-bold text-white transition-transform duration-500 ease-in-out transform translate-y-4 group-hover:translate-y-0">
                                {category.name}
                            </h3>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategorySection;